exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-1c9bcc32]{width:100%}.black[data-v-1c9bcc32],p[data-v-1c9bcc32]{color:#fff}.black[data-v-1c9bcc32]{height:50px;font-size:20px;font-weight:700;padding-left:2em}", ""]);

// exports
